import Text from 'atoms/Text';
import React, { useEffect, useState } from 'react';
import RenderFields from './RenderFields';
import Icon from 'atoms/Icon';
import { useFieldArray } from 'react-hook-form';
import { Button } from '@usitsdasdesign/dds-react';

function DynamicFields({ title, maxAllowed = 5, isMaxRestrict = true, isMaxRestrictLabel = false, isMaxRestrictlabel, onDeleteRow,
     control, register, errors, name = 'name', fieldGroup = [], label = 'label', className, setValue, actionButton, 
     grid = 'grid-cols-2', restrictLabel, fieldOptions, isRequired = false, isDisabled = false, groupLabelClass='', minimum = 0, watch }) {
    const [show, setShow] = useState(false);

    const { fields, append, remove } = useFieldArray({
        control,
        name: name
    });

    const addFieldGroup = () => {
        if (fields.length < maxAllowed) {
            append(fieldGroup.reduce((acc, field) => ({ ...acc, [field.name]: null }),{}));
        }
    };

    const handleClick = () => {
        append(fieldGroup.reduce((acc, field) => ({ ...acc, [field.name]: null }),{}));
        setShow(true);
    };

    const removeFieldGroup = (index) => {
        const rowData = watch(`${name}[${index}]`);
        if (onDeleteRow && rowData?.id) {
            onDeleteRow({
                ...rowData,
                delete: true,
                type: name === 'primarySkills' ? 'primary' : 'secondary'
            });
        }
        remove(index);
    };

    useEffect(() => {
        if(fields.length === 0) setShow(false);
        else setShow(true);
    }, [fields])

    return (
        <div className={`${className}`}>
            <div className='flex justify-between gap-2 mb-4'>
                <Text variant='bodySemibold'>
                    <span>{title}</span>
                    {isMaxRestrictLabel && <span className='text-gray-1100 text-xs font-normal'>{isMaxRestrictlabel}</span>}
                    {isMaxRestrict && <span className='text-gray-1100 text-xs font-normal'> ({minimum > 0 && `Add minimum ${minimum}, `} You can add max {maxAllowed} {restrictLabel || label})</span>}
                    {isRequired && <span className='text-red-900'>*</span>}
                </Text>
                {actionButton && <Button {...actionButton} />}
            </div>
            {
                !show && (
                    <div className={`border flex flex-col items-center justify-center h-[80px] ${errors[name] ? 'border-red-900' : ''} ${isDisabled ? 'pointer-events-none opacity-50' : 'cursor-pointer'}`}>
                        <Button
                            label={`Add ${label}`}
                            kind='primaryLoud'
                            size='s'
                            width='fixed'
                            onClick={() => {
                                if (!isDisabled) handleClick();
                            }}
                        />
                        <span className='text-gray-1100 text-xs font-normal mt-2'> You can add max {maxAllowed} {restrictLabel || label}</span>
                    </div>
                )
            }
            {
                show && (
                    <>
                        <div className='flex border-b border-neutral-50 mb-4 gap-2 md:gap-4'>
                            {
                                fieldGroup.map(group => {
                                    return (
                                        <Text variant='label' className={`py-2 flex-1 ${group.groupLabelClass}`}>{group.label}</Text>
                                    )
                                })
                            }
                            <div className='w-12'></div>
                        </div>
                        <div className='mb-4 flex flex-col gap-2 md:gap-4'>
                            {
                                fields.map((field, index) => (
                                    <div key={field.id} className='flex item-center gap-2 md:gap-4'>
                                        <RenderFields
                                            fields={fieldGroup.map((data) => ({
                                                ...data,
                                                onChange: data.onChange ? (e) => data.onChange(e, index) : null,
                                                onChangeHandler: data?.onChangeHandler ? (e) => data?.onChangeHandler(e, index) : null,
                                                options: fieldOptions && fieldOptions[data.name] && fieldOptions[data.name][`${name}[${index}]`] ? fieldOptions[data.name][`${name}[${index}]`] : data.options,
                                                name: `${name}[${index}].${data.name}`,
                                                label: '',
                                                checkboxItems: data.type ==='checkbox-group' && (watch(`${name}[${index}].${data.name}`) || data.checkboxItems)
                                            }))}
                                            setValue={setValue}
                                            control={control}
                                            register={register}
                                            errors={errors}
                                            grid={grid}
                                            gap='gap-4'
                                            className='flex-1'
                                        />
                                        <div className='flex items-center justify-center p-2 cursor-pointer'>
                                            <Icon size='w-4 h-4' icon='delete__l__stroke' onClick={() => removeFieldGroup(index)} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                       {(!isMaxRestrict || fields.length < maxAllowed) && (
                            <Button
                                label='Add more'
                                icon='plus__l__stroke'
                                kind='silent'
                                onClick={addFieldGroup}
                            />
                        )}
                    </>
                )
            }
            {errors[name] && <span className='text-red-500 text-xs error-in-field'>{errors[name].message}</span>}
        </div>
    );
}

export default DynamicFields;
